import { CssBaseline } from '@mui/material';
import { Box } from '@mui/material';

import AppBar from '../../components/appbar/appbar';
import ActivityArea from '../../components/activityArea/activityArea';
import ChatBot from '../../components/chat-bot/chat-bot';

import drawerWidth from '../../constants/mui.constants';

export interface IFullscreenLayoutProps {
  children: React.ReactNode;
}

export const FullscreenLayout = (props: IFullscreenLayoutProps) => {
	const { children } = props;
	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<AppBar width={drawerWidth} />
			<ActivityArea>{children}</ActivityArea>
			<ChatBot />
		</Box>
	);
};

export default FullscreenLayout;
